var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"grid-component"},[_c('div',{staticClass:"grid"},_vm._l((_vm.content.items),function(item,i){return _c('grid-item',{key:item.uid,attrs:{"index":i,"content":item}})}),1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }